/** 회원가입 국적 드롭다운 — 전체 학교 검색용 (DB college_country_id와 겹치지 않도록 0 사용) */
export const SIGNUP_ALL_COUNTRY_ID = 0;

export const isSignupAllCountries = (countryId: unknown): boolean =>
  Number(countryId) === SIGNUP_ALL_COUNTRY_ID;

export const isSignupCountryChosen = (countryId: unknown): boolean =>
  countryId !== '' && countryId !== undefined && countryId !== null;

/** 전체 국적 선택 시 셀렉트박스에 충분한 학교 후보를 자동 노출하기 위한 요청 크기 */
export const SIGNUP_ALL_COLLEGE_SEARCH_SIZE = 5000;

/** 회원가입 출생년대 선택지 — 10년 단위 첫해, 4자리 문자열로 전송한다 */
export const BIRTH_DECADE_OPTIONS = [
  '1950',
  '1960',
  '1970',
  '1980',
  '1990',
  '2000',
  '2010',
  '2020',
] as const;

export const BIRTH_DECADE_DEFAULT = '2020';

/** 「선택 안 함」 문구 — 이 값을 고르면 출생년대를 null 로 보낸다 */
export const BIRTH_DECADE_NONE_LABEL = '선택 안 함';

/** 저장된 출생 값('2003', '2003-05-01')을 년대 첫해('2000')로 내린다. 값이 없으면 '' */
export const toBirthDecade = (birth: unknown): string => {
  const year = /^(\d{4})/.exec(String(birth ?? ''))?.[1];
  return year ? String(Math.floor(Number(year) / 10) * 10) : '';
};
